const link =
  'https://gargleblaster.github.io/tudocs/Reference/Exit%20tactics/mfe_retracement';

const MfeRetracementDocumentation = (
  <p>
    Please refer to the docs found here: <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
  </p>
);

export default MfeRetracementDocumentation;
